import React, { memo } from 'react'
import { ApolloError } from '@apollo/client'
import { Maybe } from 'graphql/jsutils/Maybe'
import { getApolloErrorMessages } from 'transfix-ui/utils/getApolloErrorMessages'
import { IError } from 'types/graphqlTypes'
import { INLINE_MESSAGE_VARIANTS, InlineMessage } from '../InlineMessage'

export interface IApolloErrorMessagesProps {
  mutationErrors?: Maybe<IError[]>
  apolloErrors: Maybe<ApolloError>
}

const ApolloErrorMessages = memo<IApolloErrorMessagesProps>(({ apolloErrors, mutationErrors }) => {
  const errors = getApolloErrorMessages({
    apolloErrors,
    mutationErrors,
  })
  return (
    <div data-test='ApolloErrorMessages'>
      {errors.map(error => (
        <InlineMessage
          key={error}
          message={error}
          type={INLINE_MESSAGE_VARIANTS.ALERT}
          className='mb1'
          fullWidth
        />
      ))}
    </div>
  )
})

export default ApolloErrorMessages
